import React from 'react';

const defaultContextValue = {
  channel: 'desktop',
  hosts: {},
  path: '/',
  store: {},
  cookie: {},
  configService: {},
  segment: '',
  isDebugMode: false,
  isLocal: false,
  customer: {},
  mounted: false,
  isSPAEnabled: false
};

const DataProviderContext = React.createContext(defaultContextValue);

export default DataProviderContext;
